import React from "react";
import Logo from "../../../assests/logo-small.png"
export default function BrandIcon({ onClick }) {
  return (
    <img src={Logo} className="w-[180px]"/>
  );
}
